var map = {
	"./BusTaxi.png": "ec5a",
	"./CHEQUE-Circle-updated.png": "2bdd",
	"./COACH_RENEW.png": "a1dd",
	"./Circle.png": "cfd9",
	"./DSAT0046.png": "6912",
	"./DSAT0051.png": "3e09",
	"./DSAT9037.png": "35e1",
	"./Driver.png": "fb9b",
	"./DriverPayment.png": "0a13",
	"./HEADMASTER_RENEW.png": "7d9f",
	"./HZMB_FIRST_COMPANY.png": "c32d",
	"./HZMB_FIRST_PERSON.png": "503c",
	"./HZMB_RENEW_COMPANY.png": "840d",
	"./HZMB_RENEW_PERSON.png": "9966",
	"./Norm@2x.png": "36fd",
	"./NormBlack.png": "3c31",
	"./NotApproved.png": "a082",
	"./PaginationBanner.png": "d8c0",
	"./SCHOOL_RENEW.png": "483a",
	"./Success.png": "4b74",
	"./SuccessfulApproval.png": "f237",
	"./UAT.png": "cc30",
	"./booking/BusCar.png": "eca5",
	"./booking/bus.png": "9cc1",
	"./booking/car.png": "5c51",
	"./booking/other.png": "cbc5",
	"./car.png": "c013",
	"./cep.png": "8ff5",
	"./d-arrow-right.png": "6418",
	"./driv_lic.png": "6062",
	"./epay_Cert_004.png": "2028",
	"./epay_Cert_005.png": "5b96",
	"./epay_ICRenewal.png": "027d",
	"./failed.png": "98a8",
	"./general_icon.png": "d276",
	"./gov_pay.png": "4ce5",
	"./header_tc 2.png": "7447",
	"./hzmb-g.png": "78f4",
	"./hzmb-gh.png": "1f2f",
	"./hzmb-h.png": "7358",
	"./hzmbg-vehicle-company-sample.png": "fdef",
	"./hzmbg-vehicle-personal-sample.png": "4b44",
	"./index-banner.png": "fc87",
	"./logo.png": "cf05",
	"./mainlandDrivingLicenseNo_tips.png": "35d9",
	"./mainlandDrivingPermitNo_tips.png": "2a35",
	"./mobile/IndexBanner_Mobile@2x.png": "b6a5",
	"./mobile/Language.png": "b83f",
	"./mobile/PaginationBanner_Mobile@2x.png": "81de",
	"./mpay.png": "c484",
	"./scan.png": "d218",
	"./school.png": "5852"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";